import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import LoadingOverlay from '../../../shared/components/LoadingOverlay';
import addressesActionCreators from '../../store/addresses/action-creators';
import myProfileActionsCreators from '../../store/my-profile/action-creators/index';
import phonesActionCreators from '../../store/phones/action-creators';
import AddressAdd from '../common/addresses/AddressAdd';
import AddressEdit from '../common/addresses/AddressEdit';
import AddressList from '../common/addresses/AddressList';
import EditActionButton from '../common/EditActionButton';
import ListActionSubheader from '../common/ListActionSubheader';
import FormattedProperty from '../common/FormattedProperty';
import PhoneAdd from '../common/phones/PhoneAdd';
import PhoneEdit from '../common/phones/PhoneEdit';
import PhoneList from '../common/phones/PhoneList';
import MyProfileEdit from './MyProfileEdit';
import Modal from '../../../shared/ui/Modal';

class MyProfileDetail extends Component {
  constructor(props) {
    super(props);
    this.state = { isEditingProfile: false };
  }

  // ----------------------
  // Handlers
  // ----------------------

  onCloseEditProfile() {
    this.setState({ isEditingProfile: false });
  }

  onCloseEditProfilePhones() {
    this.props.closeMyProfileEditingPhones();
  }

  onCloseEditProfileAddresses() {
    this.props.closeMyProfileEditingAddresses();
  }

  onEditProfile() {
    this.setState({ isEditingProfile: true });
  }

  onSaveAddAddress(addressFormData) {
    const formData = {
      addresses: this.props.profile.getAddressesWithAdded(addressFormData),
    };
    this.props.updateProfileAddresses(formData);
  }

  onSaveAddPhone(phoneFormData) {
    const formData = {
      phones: this.props.profile.getPhonesWithAdded(phoneFormData),
    };
    this.props.updateProfilePhones(formData);
  }

  onSaveEditAddress(addressFormData) {
    const formData = {
      addresses: this.props.profile.getAddressesWithUpdated(
        this.props.isEditingAddress,
        addressFormData,
      ),
    };
    this.props.updateProfileAddresses(formData);
  }

  onSaveEditDetails(profileFormData) {
    this.props.updateProfileDetails(profileFormData).then(() => {
      this.onCloseEditProfile();
    });
  }

  onSaveEditPhone(phoneFormData) {
    const formData = {
      phones: this.props.profile.getPhonesWithUpdated(
        this.props.isEditingPhone,
        phoneFormData,
      ),
    };
    this.props.updateProfilePhones(formData);
  }

  // ----------------------
  // Computed
  // ----------------------

  get addresses() {
    return this.props.profile.addresses;
  }

  get isLoading() {
    return (
      this.props.isLoading.includes('fetchMyProfile') || !this.props.profile
    );
  }

  get phones() {
    return this.props.profile.getFormattedPhones();
  }

  // ----------------------
  // Methods
  // ----------------------

  setDefaultAddress(index) {
    const formData = {
      addresses: this.props.profile.getAddressesWithDefault(index),
      userGuid: this.props.profile,
    };
    this.props.updateProfileAddresses(formData);
  }

  setDefaultPhone(index) {
    const formData = {
      phones: this.props.profile.getPhonesWithDefault(index),
      userGuid: this.props.profile,
    };
    this.props.updateProfilePhones(formData);
  }

  deleteAddress(index) {
    const formData = {
      addresses: this.props.profile.getAddressesWithDeleted(index),
      userGuid: this.props.profile,
    };
    this.props.updateProfileAddresses(formData);
  }

  deletePhone(index) {
    const formData = {
      phones: this.props.profile.getPhonesWithDeleted(index),
      userGuid: this.props.profile,
    };
    this.props.updateProfilePhones(formData);
  }

  render() {
    return (
      <LoadingOverlay isLoading={this.isLoading}>
        {!this.isLoading && (
          <Fragment>
            <div className="app-content-header">
              <h4 className="title">My Profile</h4>
              <div>
                <button
                  className="button mr-3 secondary small"
                  onClick={() => this.props.history.push('/my-profile/change-password')}
                >
                  <i className="fa fa-pencil" />
                  <span>Change Password</span>
                </button>
                <EditActionButton
                  label="Details"
                  onEdit={() => this.onEditProfile()}
                />
              </div>
            </div>
            <div className="app-content profile">
              <ListActionSubheader title="Details" />
              <div className="card profile-details">
                <div className="profile-details-item">
                  <FormattedProperty
                    label="First Name"
                    value={this.props.profile.firstName}
                  />
                </div>
                <div className="profile-details-item">
                  <FormattedProperty
                    label="Last Name"
                    value={this.props.profile.lastName}
                  />
                </div>
                <div className="profile-details-item">
                  <FormattedProperty
                    label="Selected Role Name"
                    value={this.props.profile.roleName}
                  />
                </div>
                <div className="profile-details-item">
                  <FormattedProperty
                    label="Assigned Role Names"
                    value={this.props.profile.getRoleNames()}
                  />
                </div>
                <div className="profile-details-item">
                  <FormattedProperty
                    label="Email"
                    value={this.props.profile.email}
                  />
                </div>
                <div className="profile-details-item">
                  <FormattedProperty
                    label="Employee ID"
                    value={this.props.profile.employeeIdentifier}
                  />
                </div>
              </div>
              <PhoneList
                onAdd={() => this.props.addPhone()}
                onEdit={index => this.props.editPhone(index)}
                phones={this.phones}
                onDelete={index => this.deletePhone(index)}
                onSetDefault={index => this.setDefaultPhone(index)}
              />
              <AddressList
                onAdd={() => this.props.addAddress()}
                onEdit={index => this.props.editAddress(index)}
                addresses={this.addresses}
                onDelete={index => this.deleteAddress(index)}
                onSetDefault={index => this.setDefaultAddress(index)}
              />
            </div>

            <Modal
              isOpen={this.props.isAddingPhone}
              onClose={() => this.props.closeAddPhone()}
              title={`Add Phone for ${this.props.profile.getFullName()}`}
            >
              <PhoneAdd onSave={formData => this.onSaveAddPhone(formData)} />
            </Modal>

            <Modal
              isOpen={this.props.isEditingPhone !== -1}
              onClose={() => this.props.closeEditPhone()}
              title={`Edit Phone for ${this.props.profile.getFullName()}`}
            >
              <PhoneEdit
                phone={this.props.profile.phones[this.props.isEditingPhone]}
                onSave={formData => this.onSaveEditPhone(formData)}
              />
            </Modal>

            <Modal
              isOpen={this.props.isAddingAddress}
              onClose={() => this.props.closeAddAddress()}
              title={`Add Address for ${this.props.profile.getFullName()}`}
            >
              <AddressAdd
                onSave={formData => this.onSaveAddAddress(formData)}
              />
            </Modal>

            <Modal
              isOpen={this.props.isEditingAddress !== -1}
              onClose={() => this.props.closeEditAddress()}
              title={`Edit Address for ${this.props.profile.getFullName()}`}
            >
              <AddressEdit
                address={this.addresses[this.props.isEditingAddress]}
                onSave={formData => this.onSaveEditAddress(formData)}
              />
            </Modal>

            <Modal
              isOpen={this.state.isEditingProfile}
              onClose={() => this.onCloseEditProfile()}
              title="Edit My Profile"
            >
              <MyProfileEdit
                profile={this.props.profile}
                onSave={formData => this.onSaveEditDetails(formData)}
              />
            </Modal>
          </Fragment>
        )}
      </LoadingOverlay>
    );
  }
}

// ----------------------
// Redux Mappings
// ----------------------

const mapStateToProps = (state) => {
  return {
    isAddingAddress: state.addresses.isAddingAddress,
    isAddingPhone: state.phones.isAddingPhone,
    isEditingAddress: state.addresses.isEditingAddress,
    isEditingPhone: state.phones.isEditingPhone,
    isLoading: state.myProfile.isLoading,
    profile: state.myProfile.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addPhone: () => {
      return dispatch(phonesActionCreators.addPhone());
    },
    addAddress: () => {
      return dispatch(addressesActionCreators.addAddress());
    },
    closeAddAddress: () => {
      return dispatch(addressesActionCreators.closeAddAddress());
    },
    closeAddPhone: () => {
      return dispatch(phonesActionCreators.closeAddPhone());
    },
    closeEditAddress: () => {
      return dispatch(addressesActionCreators.closeEditAddress());
    },
    closeEditPhone: () => {
      return dispatch(phonesActionCreators.closeEditPhone());
    },
    editAddress: (index) => {
      return dispatch(addressesActionCreators.editAddress(index));
    },
    editPhone: (index) => {
      return dispatch(phonesActionCreators.editPhone(index));
    },
    updateProfileAddresses: (formData) => {
      return dispatch(myProfileActionsCreators.updateMyProfileAddresses(formData));
    },
    updateProfileDetails: (formData) => {
      return dispatch(myProfileActionsCreators.updateMyProfile(formData));
    },
    updateProfilePhones: (formData) => {
      return dispatch(myProfileActionsCreators.updateMyProfilePhones(formData));
    },
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(MyProfileDetail));
